import { faImage, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

const Wrapper = styled.div`
  display: flex;
  line-height: 38px;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
`;

const Details = styled.div`
  color: ${colours.greyDarkAlt2};
  display: flex;
  align-items: center;
  width: 85%;
`;

const Icon = styled(FontAwesomeIcon)`
  margin: 0 10px;
  color: ${colours.greyLightAlt3};
  font-size: 20px;
`;

const DeleteButton = styled.button`
  margin-left: auto;
  outline: none;
  border: none;
  padding: 0 10px;
  background: none;
  color: ${colours.greyDarkAlt2};

  &:hover {
    background: ${colours.greyLightAlt3};
    color: #ffffff;
  }
`;

const ImageName = styled.span`
  line-height: normal;
  padding-right: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

interface SelectedImageProps {
  className?: string;
  imageClassName?: string;
  deleteClassName?: string;
  deleteIconClassName?: string;
  imageName: string;
  onDeleteClick: () => void;
}

const SelectedImage = ({
  imageName,
  className,
  imageClassName,
  deleteClassName,
  deleteIconClassName,
  onDeleteClick,
}: SelectedImageProps) => {
  return (
    <Wrapper className={className}>
      <Details>
        <Icon icon={faImage} />
        <ImageName className={imageClassName}>{imageName}</ImageName>
      </Details>
      <DeleteButton className={deleteClassName} onClick={onDeleteClick}>
        <FontAwesomeIcon className={deleteIconClassName} icon={faTrash} />
      </DeleteButton>
    </Wrapper>
  );
};

export default SelectedImage;
